export default __webpack_public_path__ + "static/media/MF.783ccc65.svg";